import "globals";

(function (window, document, $) {

    // initialize slick when node is created in the backend
    const handleNodeCreated = function (event) {
        const createdElement = event.detail.element;
        const slider = createdElement.closest(".logo-slider");

        if (createdElement.classList.contains("logo-slider") && $.prototype.slick) {
            $(createdElement).find(".slider__items").slick();
        }
        // child element created
        if (createdElement != slider && $.prototype.slick) {
            $(slider).find(".slider__items").slick("unslick");
            $(slider).find(".slider__items").slick();
        }
    };

    const onContentReloaded = (event) => {
        const contextPath = event.detail.contextPath;

        const domNode = document.querySelector(`[data-__neos-node-contextpath="${contextPath}"]`);
        if (!domNode) {
            return;
        }
        const slider = domNode.closest(".logo-slider");
        try {
            $(slider).find(".slider__items").slick("getSlick");
        } catch (e) {
            $(slider).find(".slider__items").slick();
        }
    };

    const onNodeSelected = (event) => {
        const node = event.detail.node;

        if (!node) {
            return;
        }

        const contextPath = node.contextPath;

        const domNode = document.querySelector(`[data-__neos-node-contextpath="${contextPath}"]`);
        if (!domNode) {
            return;
        }
        const slider = domNode.closest(".logo-slider");

        if (slider && domNode != slider) {
            const slide = domNode.closest(".slick-slide");

            const index = slide.dataset.slickIndex;

            $(slider).find(".slider__items").slick("slickGoTo", index, false);
        }
    };

    const onNodeRemoved = (event) => {
        const element = event.detail.element;

        const slider = document.querySelector(`#${element.dataset.slider}`);

        if (!slider) {
            return;
        }

        const sliderItems = slider.querySelectorAll(".logo-slider__item");

        for (let i = 0; i < sliderItems.length; i++) {
            const slide = sliderItems[i];
            if (slide.children.length === 0) {
                const slideEl = slide.closest(".slick-slide");

                const allSlideEls = Array.from(slider.querySelectorAll(".slick-slide"));
                const index = allSlideEls.indexOf(slideEl);

                $(slider).find(".slider__items").slick("slickRemove", index);
            }
        }
    };

    document.addEventListener("Neos.ContentReloaded", onContentReloaded, false);
    document.addEventListener("Neos.NodeCreated", handleNodeCreated, false);
    document.addEventListener("Neos.NodeSelected", onNodeSelected, false);
    document.addEventListener("Neos.NodeRemoved", onNodeRemoved, false);
})(window, document, jQuery);
